import { FC, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';

import styles from './PlainDialog.module.scss';

type PlainDialogProps = {
  isOpen: boolean;
  children?: ReactNode;
  addClass?: string[];
};

//DialogコンポーネントのheadlessuiのDialogが強制的に親でスクロールロックを入れる実装になっており、
//マップ表示のダイアログでピンチズームができない問題があるので、
//スクロールのロックを自前で制御するシンプルなダイアログを実装してこの問題を回避する
//iOS, mobile safariでロック制御の問題が出やすい

function lockScroll() {
  const scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function unlockScroll() {
  const scrollY = document.body.style.top;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
}

export const PlainDialog: FC<PlainDialogProps> = ({ isOpen, children, addClass = [] }) => {
  useEffect(() => {
    if (isOpen) {
      lockScroll();
      return () => unlockScroll();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className={[styles.dialog, ...addClass].join(' ')} role="dialog" aria-modal="true">
      <div className={styles.screen} />
      <div className={styles.content}>{children}</div>
    </div>,
    document.body
  );
};
